import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import MESSAGE from '../../../business-const/Message/Message'

import {
    CLASSNAME
} from '../../../business-const/Style/Style'



const EstudoReportOQueEsperarDesseTrabalho = ({ values, jsonConfiguracao }) => {

    return (
        <div
            align="left"
            className={
                values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato
                    ?
                        CLASSNAME().formataReportOQueEsperarDesseTrabalhoRetrato
                    :
                        CLASSNAME().formataReportOQueEsperarDesseTrabalhoPaisagem
            }
            dangerouslySetInnerHTML={{ __html: 
                jsonConfiguracao && jsonConfiguracao.estudoReportOQueEsperarDesseTrabalho
                    ?
                        jsonConfiguracao.estudoReportOQueEsperarDesseTrabalho
                    :
                        MESSAGE().estudoReportOQueEsperarDesseTrabalho
            }}
        />
    )
}

export default EstudoReportOQueEsperarDesseTrabalho